import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SliderGetAll } from '../../services';

export const fetchSliderGetAll = createAsyncThunk(
    'sliderGetAll/fetchSliderGetAll',
    async () => {
        const response = await SliderGetAll()
        return response.result
    }
);

const sliderGetAllSlice = createSlice({
    name: 'sliderGetAll',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSliderGetAll.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSliderGetAll.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSliderGetAll.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default sliderGetAllSlice.reducer;
